import { render, staticRenderFns } from "./VpnSettingsInstructions.vue?vue&type=template&id=ef617c66&scoped=true"
import script from "./VpnSettingsInstructions.vue?vue&type=script&lang=js"
export * from "./VpnSettingsInstructions.vue?vue&type=script&lang=js"
import style0 from "./VpnSettingsInstructions.vue?vue&type=style&index=0&id=ef617c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef617c66",
  null
  
)

export default component.exports